import * as React from 'react';

function RecipeFiltersIcon(props) {
	return (
		<svg
			width={13}
			height={16}
			xmlns="http://www.w3.org/2000/svg"
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}
		>
			<g
				transform="translate(0 1.5)"
				stroke="#000"
				strokeWidth={1.5}
				fill="none"
				fillRule="evenodd"
			>
				<path
					strokeLinecap="square"
					d="M.813 1.625h11.375M.813 6.5h11.375M.813 11.375h11.375"
				/>
				<circle fill="#FFF" cx={9.75} cy={1.625} r={1.625} />
				<circle fill="#FFF" cx={9.75} cy={11.375} r={1.625} />
				<circle fill="#FFF" cx={3.25} cy={6.5} r={1.625} />
			</g>
		</svg>
	);
}

export default RecipeFiltersIcon;
